import Admin from '@/components/admin/Admin'
import Dashboard from '@/components/admin/dashboard/Dashboard'
import DashboardUser from '@/components/admin/dashboard/DashboardUser'
import AdminProfile from '@/components/admin/user/AdminProfile'
import ListUser from '@/components/admin/user/ListUser'
import Team from '@/components/admin/team/Team'
import TaskComponent from '@/components/admin/task/TaskComponent'
import TaskHoursMonth from '@/components/admin/task/TaskHoursMonth'
import Campaigns from '@/components/admin/campaign/CampaignsTeam'
import CalendarUser from '@/components/admin/calendar/CalendarUser'
import Week from '@/components/admin/calendar/Week'
import AccountUser from '@/components/admin/account/AccountUser'
import EmailTeam from '@/components/admin/email/EmailTeam'
import EmailPending from '@/components/admin/email/EmailTeam'
import EmailCheck from '@/components/admin/email/EmailCheck'
import ListLibrary from '@/components/admin/library/ListLibrary'
import LibraryTeam from '@/components/admin/library/LibraryTeam'
import ListActivity from '@/components/admin/activity/ListActivity'
import ListPoints from '@/components/admin/points/ListPoints'
import CreateActivity from '@/components/admin/activity/CreateActivity'
import ListParticipations from '@/components/admin/activity/ListParticipations'
import ListUserAnswers from '@/components/admin/activity/ListUserAnswers'
import AccountsAuth from '@/components/admin/user/AccountsAuth'
import Platforms from '@/components/admin/user/Platforms'
import ReportTasks from '@/components/admin/report/ReportTasks'
import ListNotes from '@/components/admin/note/ListNotes'
import ListDevelopments from '@/components/admin/development/ListDevelopments'
import Planning from '@/components/admin/planning/Planning'

export default {
  path: '/admin',
  //beforeEnter: requireAuth,
  name: 'Admin',
  component: Admin,
  children: [
    {
      path: 'dashboard',
      component: Dashboard,
    },
    {
      path: 'home',
      component: DashboardUser,
    },
    {
      path: 'team',
      component: Team,
    },
    {
      path: 'tasks',
      component: TaskComponent,
    },
    {
      path: 'hours-tasks',
      component: TaskHoursMonth,
    },
    {
      path: 'pendings-tasks',
      component: TaskComponent,
    },
    {
      path: 'emails',
      component: EmailTeam,
    },
    {
      path: 'pendings-emails',
      component: EmailPending,
    },
    {
      path: 'emails-check',
      component: EmailCheck,
    },
    {
      path: 'emails-check/:id',
      component: EmailCheck,
    },
    {
      name: 'campaigns',
      path: 'campaigns',
      component: Campaigns,
    },
    {
      path: 'profile',
      component: AdminProfile,
    },
    {
      path: 'notes',
      component: ListNotes,
    },
    {
      path: 'developments',
      component: ListDevelopments,
    },
    {
      path: 'accounts-auth',
      component: AccountsAuth,
    },
    {
      path: 'users',
      component: ListUser,
    },
    {
      path: 'libraries',
      component: ListLibrary,
    },
    {
      path: 'library',
      component: LibraryTeam,
    },
    {
      name: 'calendar',
      path: 'calendar/:id',
      component: CalendarUser,
    },
    {
      path: 'week',
      component: Week,
    },
    {
      path: 'account-user/:id',
      component: AccountUser,
    },
    {
      path: 'points',
      component: ListPoints,
    },
    {
      path: 'activities',
      component: ListActivity,
    },
    {
      name: 'create-activity',
      path: 'activities/create',
      component: CreateActivity,
    },
    {
      name: 'edit-activity',
      path: 'activities/:slug/questions',
      component: CreateActivity,
    },
    {
      name: 'show-activity',
      path: 'activities/:slug',
      component: CreateActivity,
    },
    {
      name: 'show-activity-participation',
      path: 'activities/:slug/participations',
      component: ListParticipations,
    },
    {
      name: 'show-user-answers',
      path: 'activities/:slug/answers',
      component: ListUserAnswers,
    },
    {
      path: 'platforms',
      component: Platforms,
    },
    {
      path: 'reports',
      component: ReportTasks,
    },
    {
      path: 'planning',
      component: Planning,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/admin.js